(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('genfileupload', {
      restrict: 'E',
      bindings: {
      },
      template: `
        <fileupload
            parentsave="vm.savewithoutsigning(filedata)"
            label="Hinaufladen ohne Vidierung"
            color="success">
        </fileupload>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog',
        function ($log, File, Rlog) {
          let vm = this;
          vm.savewithoutsigning = savewithoutsigning;

          function savewithoutsigning(filedata) {
            File.$find(filedata.fileid).$then(function (file) {
              $log.debug('save filewithsigning: ', file);
              file.scanstatus = 'finished';
              file.signedoff = 'false';
              file.doccat = 'generic';
              file.active = true;
              file.$save();
            }, function (err) {
              $log.error('fileupload metdata could not be retrieved for further editing: ', err);
              Rlog.error('vcdms.file', 'genfileupload', 'fileupload metdata could not be retrieved for further editing', {fileid: filedata.fileid});
            });
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
